import requestor from "requestor";
import React, {useState, useEffect} from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import CircularProgress from "@material-ui/core/CircularProgress";

import llmRunBatchScoresFetchAction, {
  GetLlmRunsBatchScoresAction,
} from "modules/flowmaster/actions/llm_runs_batch_scores_fetch";

import Permissioner from "utils/permissioner";
import {isInitialised} from "utils/uninitialised";
import setTitle from "utils/set_title";
import ScoresComponent from "../components/scores";

import {RouterState, InjectedRouter} from "react-router/lib/Router";
import {Organisation} from "common/types/organisation";
import {User} from "common/types/user";
import {LlmRunBatchInfo, LlmRunScore} from "common/flowmaster/types/llm_run";

interface Props {
  user: User;
  router: RouterState & InjectedRouter;
  location: Location;
  params: {
    organisationId: string;
  };
  dispatch: (args: unknown) => unknown;
  organisation: Organisation;

  batches: LlmRunBatchInfo[];
  batchScores: LlmRunScore[];

  fetchBatchScores: GetLlmRunsBatchScoresAction["action"];
}
function SearcherContainer({
  user,
  router,
  batches,
  batchScores,
  fetchBatchScores,
}: Props) {
  const organisationId = parseInt(router.params.organisationId, 10);

  const [selectedBatches, setSelectedBatches] = useState<string[]>([]);
  useEffect(() => {
    if (selectedBatches.length) {
      fetchBatchScores(organisationId, selectedBatches);
    }
  }, [selectedBatches]);

  const updateBatches = _batches => {
    setSelectedBatches(_batches);
  };

  const permissioner = new Permissioner(user);
  if (
    !(permissioner.hasPermission("get-workflows") || permissioner.isAdmin())
  ) {
    return permissioner.getNoPermissionMessage();
  }

  setTitle("LLM Run Scores");

  const shouldRenderContainer = isInitialised([user, batches]);
  if (!shouldRenderContainer || !user.permissions) {
    return (
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <ScoresComponent
      organisationId={organisationId}
      runScores={isInitialised(batchScores) ? batchScores : []}
      batches={batches}
      selectedBatches={selectedBatches}
      setSelectedBatches={updateBatches}
    />
  );
}

function select(state) {
  return {
    user: state.user,
    organisation: state.organisation,
    batchScores: state.batchScores,
    batches: state.llmRunBatches,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(
      {
        fetchBatchScores: llmRunBatchScoresFetchAction(requestor),
      },
      dispatch,
    ),
  };
}

export default connect(select, mapDispatchToProps)(SearcherContainer);
